import React from 'react';

// Styles & Assets
import helpers from '../../../styles/Helpers.module.css';
import { TbArrowBackUp } from 'react-icons/tb';

// Hooks
import { useTranslation } from 'react-i18next';

// Interfaces
interface Props {
    defaultPreconfigID: number
    patientID: number
    handleUnassign: () => void
}

const PatientPreconfigRestore: React.FC<Props> = ({
    handleUnassign
}) => {

    const { t } = useTranslation();

    return (
        <button
            className={helpers.unassignButton}
            onClick={handleUnassign}
        >
            <TbArrowBackUp />
            {t('restore_preconfig')}
        </button>
    );
};

export default PatientPreconfigRestore;